module.exports = __webpack_public_path__ + "static/media/prinz-eugen-lose.a0a81adc.png";